import { styled, keyframes } from "@mui/material/styles"
import { Box } from "@mui/material"

export const loadingShimmer = keyframes`
  0% { background-position: 0% 50%; }
  50% { background-position: 100% 50%; }
  100% { background-position: 0% 50%; }
`

export const Panel = styled(Box)({
  position: "relative",
  display: "flex",
  flexFlow: "row nowrap",
  margin: "16px 0",
  backgroundColor: "var(--app-bg-paper)",
  transition: "margin 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms",
  boxShadow: [
    "0 1px 3px 0 var(--app-shared-shadow-color-alpha)",
    "0 1px 1px 0 var(--app-shared-shadow-color-alpha-2)",
    "0 2px 1px -1px var(--app-divider)",
  ].join(", "),
  "&::before": {
    content: "\"\"",
    position: "absolute",
    top: -1,
    left: 0,
    right: 0,
    height: 1,
    opacity: 1,
    transition: "opacity 150ms cubic-bezier(0.4, 0, 0.2, 1) 0ms, background-color 150ms cubic-bezier(0.4, 0, 0.2, 1) 0ms",
    backgroundColor: "var(--mui-palette-divider)",
  },
})

export const GroupSelectArea = styled(Box)({
  position: "relative",
  display: "flex",
  flex: "0 0 calc(100% / 6)",
  paddingTop: "10px",
  paddingLeft: "2rem",
  paddingRight: "0.5rem",
})

export const GroupSelectorBox = styled(Box)({
  flex: "1 0",
})

export const ShowAllToggleBox = styled(Box)({
  flex: "0 1",
  marginLeft: "0.75rem",
})

// Was implicitly `display: flex` via legacy MUI Grid v1's default container behavior; Grid v2
// defaults to `display: grid` instead, which silently broke this stacking (title row above
// values). Made explicit so it no longer depends on which Grid version happens to be installed.
export const ContentArea = styled(Box)({
  display: "flex",
  flexDirection: "column",
  flex: "0 0 calc((100% / 6) * 5)",
  overflow: "hidden",
})

export const TitleRowBox = styled(Box)({
  display: "flex",
  flexFlow: "row nowrap",
  overflowX: "hidden",
  borderBottom: "1px solid var(--opcolor-grey-base)",
})

export const ValuesBox = styled(Box)({
  display: "flex",
  flexFlow: "row nowrap",
  maxHeight: 400,
  overflow: "hidden",
})

export const GroupColumn = styled(Box)({
  position: "relative",
  flex: "0 0 calc(100% / 5)",
})

export const BackgroundColorLayer = styled(Box)({
  position: "absolute",
  top: 0,
  left: 0,
  width: "100%",
  height: "100%",
})

export const ContentWrapper = styled(Box)({
  position: "relative",
  height: 40,
})

export const ChartBar = styled(Box)({
  position: "absolute",
  top: 0,
  left: 0,
  bottom: 0,
  opacity: 0.1,
})

export const ValueWrapper = styled(Box)({
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  height: "100%",
  position: "relative",
  paddingLeft: "1rem",
  paddingRight: "1rem",
  "& span": {
    whiteSpace: "nowrap",
  },
})
